module.exports = __webpack_public_path__ + "img/crown.1e4d07a5.svg";